import { AbstractDataSourceModel } from '../../../../Common/Misc/models/abstract-data-source.model';
import { Observable ,  of } from 'rxjs';
import { LinksItemModel } from '../../../Shared/components/Links/links-data-item.model';
import { Injectable } from '@angular/core';

@Injectable()
export class StoryLinksDataSource extends AbstractDataSourceModel {
    public dataSource: LinksItemModel[] = [];

    public all(): Observable<any> {
        return of(this.dataSource);
    }

    public search(): Observable<any> {
        return of(this.dataSource);
    }

    public addLink(item: LinksItemModel): void {
        this.dataSource.push(item);
    }

    public updateLink(item: LinksItemModel, index: number): void {
        this.dataSource[index] = item;
    }

    public deleteLink(item: LinksItemModel): void {
        this.dataSource.splice(this.dataSource.indexOf(item), 1);
    }
}
